export class Booking {
    
    Reuest_Number:string;
    Booking_Number:string;
    Booking_Date:string;
    Booking_Details:string;
    Booking_Breakup:Booking_Breakup[]=[];
    Booking_Type:string;
    Category_Id:string;
    Check_In_Date:Date;;
    Check_Out_Date:Date;
    No_Of_Nights:number=0;
    No_Of_Booking:number=1;
    No_Of_Adult:number=0;
    No_Of_Child:number=0;
    Price:number=0;
    Extra_Bed:number=0;
    Extra_Bed_Rate:number=0;
    Extra_Bed_Price:number=0;
    Adult_Meal:number=0;
    Adult_Meal_Rate:number=0;
    Adult_Meal_Price:number=0;
    Child_Meal:number=0;
    Child_Meal_Rate:number=0;
    Child_Meal_Price:number=0;
    Combined_Price:number=0;
    Discount_Type:string;
    Discount:number=0;
    Discount_Amount:number=0;
    Taxes_Amount:number=0;
    Final_Price:number=0;
    Paid_Amount:number=0;
    Balance_Amount:number=0;
    Payment_Mode:string = '';
    Payment_Ref_No:string; 
    Guest_Name:string;
    Email:string;
    Phone_No:string;
    Special_Request:string;
    Title : string = '';
    Status:string;
    termsandCondition : boolean=false;
    privacyPolicy : boolean=false;
}
export class Booking_Breakup
{
Adult:number=1;
Child:number=0;
Child_Age:number[]=[];
No_of_Room : number=0;
}
 
 
 
 
 
